import { useMemo } from 'react'
import { MdOutlineViewList } from 'react-icons/md'

import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { ResourceList } from '@/Core/UI/CrudResource/ResourceList'

import { TaskResource } from '../Resources/TaskResource'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * «Усі завдання» — без предметного prefilter (SPEC-008 §4.4). Обсяг ріже бекенд
 * (`TaskRule.applyToCollection`, SPEC-005 §4); видалені приховує `RemovedExtension`.
 */
export default function AllTasksPage() {
    const listContext = useMemo(
        () =>
            createCrudResourceContext({
                contextType: 'list',
                registryKey: 'Task.All.list',
                resource: TaskResource,
                // Каст на межі нетипізованої .jsx-фабрики: її inferred-параметр не містить
                // resource/prefilter/list (їх фабрика читає через ...props у рантаймі).
                // Приводимо до її ж параметра — без `any` (пор. Core `UniversalResourcePage.tsx:70`).
            } as unknown as Parameters<typeof createCrudResourceContext>[0]),
        []
    )

    // `registryKey` обов'язковий у типі `ResourceList` ЦІЛІ — лишаємо свідомо (§хвіст 05.4).
    return <ResourceList crudContext={listContext} registryKey="Task.All.list" />
}

export const pageConfig: IPageConfig = {
    key: 'Task.All',
    title: 'Усі завдання',
    icon: <MdOutlineViewList />,
}
